// removed by extract-text-webpack-plugin
module.exports = {"header":"_3bMN686qBPYP1df9uC_kfN","header-logo-container":"_1SJihO7DtHxdvYVdlcDm0n","header-logo":"_2JzmaQ_n-g_MzaIn1gwQF_","header-dropdown":"_2a--O9FgLsLT1LzLxGz892","user-dropdown":"_3urqWbG0kty7kj6Dm7R35o"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Header.scss
// module id = 1174
// module chunks = 1